import PropTypes from "prop-types";
import GenericModal from "./generic-modal.component";
import AlignedImageBox2 from "../image-boxes/aligned-image-box/aligned-image-box-2";
import { nairaFormart } from "../../utils/functions";

export default function PropertiesModal({
  action,
  close,
  state,
  properties,
  handlePropertySelect,
}) {
  return (
    <GenericModal
      onClick={(event) => {
        if (event.target.classList.contains("close-modal")) {
          action();
        }
      }}
      modalState={state}
    >
      <div className="bg-white w-full p-4 sm:p-6 justify-center items-center text-center relative rounded-md">
        <button
          onClick={() => close()}
          className="close-modal py-1 px-3 rounded-full border border-black absolute top-3 right-3 hover:bg-gray-100 transition-colors z-10 text-sm"
        >
          X
        </button>
        
        <div className="flex flex-col gap-4 justify-center items-center w-full mt-2">
          <h3 className="font-bold text-[18px] sm:text-[20px] header-font">Select a property</h3>
          
          <div className="flex flex-col w-full max-h-[60vh] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
            {properties.map((data, index) => {
              const isOccupied = data?.acf?.occupancy_status === true 

              return (
                <button 
                  key={index} 
                  disabled={isOccupied}
                  className={`flex items-center border-b w-full rounded-sm p-2 sm:p-3 transition-colors ${
                    isOccupied ? "opacity-50 cursor-not-allowed bg-gray-50" : "hover:bg-gray-50 cursor-pointer"
                  }`}
                  onClick={() => !isOccupied && handlePropertySelect(data)}
                >
                  <div className="flex items-center gap-2 sm:gap-3 w-full text-left">
                    <div className="w-4 shrink-0 font-medium text-gray-500 text-xs sm:text-sm">
                      {index + 1}
                    </div>
                    
                    <div className="w-[45%] sm:w-[40%] shrink-0 min-w-0">
                      <AlignedImageBox2
                        profileImage={data?.acf?.photo_gallery?.gallery?.[0]?.[0]?.full_image_url}
                        text={data?.title}
                        subtext={data?.property_type}
                      />
                    </div>
                    
                    <div className="flex-1 min-w-0 px-1">
                      <div 
                        className="truncate text-[11px] sm:text-xs text-gray-600" 
                        title={data?.acf?.address}
                      >
                        {data?.acf?.address}
                      </div>
                    </div>
                    
                    <div className="shrink-0 font-medium text-right text-[11px] sm:text-sm">
                      {isOccupied ? (
                        <span className="text-red-500 bg-red-50 px-2 py-1 rounded-md text-[10px] sm:text-xs font-semibold">Occupied</span>
                      ) : (
                        <span className="text-primary">{nairaFormart(data?.acf?.price)}</span>
                      )}
                    </div>
                  </div>
                </button>
              );
            })}
            
            {properties.length === 0 && (
              <p className="text-gray-500 py-8 text-sm">No properties available.</p>
            )}
          </div>
        </div>
      </div>
    </GenericModal>
  );
}

PropertiesModal.propTypes = {
  action: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  state: PropTypes.bool.isRequired,
  properties: PropTypes.array.isRequired,
  handlePropertySelect: PropTypes.func.isRequired,
};